import { CreateUserErrors } from '../user-session/user-session.state';

export interface PasswordManagementState {
  resetPasswordErrors?: CreateUserErrors;
}

export const initialPasswordManagementState: PasswordManagementState = {};

export const PasswordPattern =
  /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[! #$%&()*+,\-./:=?@[\]^_{}~])[! #$%&()*+,\-./:=?@[\]^_{}~a-zA-Z\d]*$/;
